export default __webpack_public_path__ + "static/media/TCExp.a2345a1d.md";